import { fetchBuyMenuConditionKind } from "@Services/buyCarMenu";
import React from "react";
import { useQuery } from "react-query";

const LabelItem: React.FC<any> = ({ name }) => {
  return (
    <div
      className='w-90 bg-[#F0F6FF] text-14 px-18 whitespace-pre'
      style={{ textAlignLast: "justify", lineHeight: "46px" }}
    >
      {name}
    </div>
  );
};

const Item: React.FC<any> = ({ data, action, onChange, name }) => {
  return (
    <>
      {data.map((item, index: number) => (
        <div
          className={`${
            action === `${item.value}` ? "bg-[#4364FF] text-white" : ""
          } cursor-pointer px-6  rounded-4 h-30 flex items-center justify-center  select-none`}
          key={index}
          data-id={item.value}
          onClick={() => {
            onChange(item, { value: item.field, name: name });
          }}
        >
          {item.enName || item.name}
        </div>
      ))}
    </>
  );
};

const KindCondition: React.FC<any> = ({ kind, allBrand, brandId, onChange, kindId }) => {
  const { data = kind } = useQuery<any>([`fetchBuyMenuConditionKind`, brandId], async () => {
    const res = await fetchBuyMenuConditionKind({ brandId: brandId });
    return res?.status === 12000 && res.data.length !== 0 ? res.data : kind;
  });

  return (
    <div className='flex gap-12' id='kindList'>
      <LabelItem name='車款' />
      <div className='flex gap-8  w-800 flex-wrap pt-8'>
        {data.length > 0 && (
          <Item
            onChange={(items, keys) => {
              let brandItems: any = {};
              allBrand.map((item) => {
                item.items.map((vv) => {
                  if (vv.value === items.brandId) {
                    brandItems = vv;
                  }
                });
              });

              onChange(items, keys, brandItems);
            }}
            data={data}
            action={kindId}
            name={"kindIdName"}
          />
        )}
      </div>
    </div>
  );
};
export default KindCondition;
